import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type {
	IAttachment,
	IOrderMessage,
	IOrderMessages,
} from '@interfaces/orderMessage';
import type { AttachFileData } from '@interfaces/file';

export interface IGetOrderMessagesParams {
	visualized?: boolean;
	search?: string;
	orderId?: number;
	clientId?: number;
	sellerId?: number;
	messageId?: number;
	tenantId?: number;
	createdAfter?: Date | string;
	updateAfter?: Date | string;
	page?: number;
	pageLimit?: number;
}

@Injectable({
	providedIn: 'root',
})
export class OrderMessagesService {
	constructor(private readonly _http: HttpClient) {}

	getOrderMessages(queryParams?: IGetOrderMessagesParams) {
		return this._http.get<IOrderMessages>('orders/messages', {
			params: (<unknown>queryParams) as HttpParams,
		});
	}

	getOrderMessage(id: IOrderMessage['id']) {
		return this._http.get<IOrderMessage>(`orders/messages/${id}`);
	}

	newOrderMessage(orderMessage: IOrderMessage) {
		return this._http.post<IOrderMessage>('orders/messages', orderMessage);
	}

	visualized(messageIds: number[]) {
		return this._http.post<IOrderMessage>('orders/messages/visualized', {
			messageIds,
		});
	}

	deleteOrderMessage(id: IOrderMessage['id']) {
		return this._http.delete<IOrderMessage>(`orders/messages/${id}`);
	}

	newAttachment(file: AttachFileData, data: any) {
		const formData = new FormData();
		formData.append('file', file.file, file.filename);
		formData.append('messageId', data.messageId);
		formData.append('orderId', data.orderId);

		return this._http.post<IAttachment>(
			`orders/messages/attachments`,
			formData
		);
	}

	deleteAttachment(attachmentId: IAttachment['id']) {
		return this._http.delete<IAttachment>(
			`orders/messages/attachments/${attachmentId}`
		);
	}
}
